module.exports = __webpack_public_path__ + "static/media/monaSerenoImg.63502637.png";